module.exports = __webpack_public_path__ + "img/red_057.4ffe6f67.png";